<div class="row align-items-center">
    <div class="col-sm-8">
        <h2>Send Push Notification</h2>
    </div>
    <div class="col-sm-4 d-flex justify-content-end align-items-center">
        <h5 class="mb-0 text-nowrap me-2">Send notification to store</h5>
        <nb-toggle [(ngModel)]="showStoreInput" (ngModelChange)="toggleInput($event)"></nb-toggle>
    </div>
</div>


<form [formGroup]="notificationForm">
    <div class="row" style="margin-top: 20px;">
        <div class="col-sm-6">
            <label class="form-label">Type</label>
            <ng-select fullWidth bindLabel="typeName" bindValue="value" [searchable]="true" placeholder="Type"
                formControlName="type" (change)="onTypeChange()" [clearable]="false">
                <ng-option *ngFor="let option of type" [value]="option.value">{{ option.typeName }}</ng-option>
            </ng-select>
        </div>
        <div class="col-sm-6">
            <label class="form-label">Title</label>
            <input class="form-control" placeholder="Enter Title" formControlName="title" />
            <!-- <div *ngIf="notificationForm.get('title').invalid && notificationForm.get('title').touched"
                class="text-danger">
                Title is required
            </div> -->
        </div>


        <div class="row" style="margin-top: 20px;">
            <div class="col-sm-6" *ngIf="!showStoreInput">
                <label class="form-label">User</label>
                <ng-select [items]="userSuggestions" bindLabel="name" bindValue="id"
                    placeholder="Select or type to search" formControlName="userId" [multiple]="true"
                    (search)="onKeySearch()">
                    <ng-template ng-header-tmp>
                        <div>
                            <button class="btn btn-link" (click)="onSelectAll()">Select All</button>
                            <button class="btn btn-link" (click)="onClearAll()">Clear All</button>
                        </div>
                    </ng-template>
                    <ng-option *ngFor="let user of userSuggestions" [value]="user.id">
                        {{ user.name }}
                    </ng-option>
                </ng-select>
            </div>

            <div class="col-sm-6" *ngIf="showStoreInput">
                <label class="form-label">Store</label>
                <ng-select [items]="stores" bindLabel="storeName" bindValue="id" placeholder="Select store"
                    formControlName="storeId">
                    <ng-option *ngFor="let store of stores" [value]="store.id">
                        {{ store.storeName }}
                    </ng-option>
                </ng-select>
            </div>
            <div class="col-sm-6" *ngIf="notificationForm.get('type').value==='text'">
                <label class="form-label">Text Content</label>
                <textarea class="form-control" placeholder="Enter Text Content"
                    formControlName="description"></textarea>
            </div>
            <div class="col-sm-6" *ngIf="notificationForm.get('type').value==='media'">
                <label class="form-label">Media</label>
                <div class="image-container">
                    <div *ngFor="let imageUrl of imageArr; let i = index" class="image-item">
                        <img [src]="imageUrl" height="50" />
                        <i (click)="removeImage(i)" class="fa-solid fa-trash-can me-2"></i>
                    </div>

                    <div *ngFor="let videoUrl of videoArr; let i = index" class="video-item">
                        <video height="100" controls>
                            <source [src]="videoUrl" type="video/mp4">
                        </video>
                        <i (click)="removeVideo(i)" class="fa-solid fa-trash-can me-2"></i>
                    </div>

                    <label class="file-label" for="exampleInputFile">
                        <input type="file" name="logoImageUrl" multiple accept="image/*, video/*" id="exampleInputFile"
                            (change)="updateFile($event)" formControlName="media" />
                        <img src="assets/images/plusnew.png" height="50" />
                    </label>
                </div>

            </div>
        </div>

    </div>
    <button type="submit" (click)="sendNotification()" class="btn btn-primary mt-4" style="float: right;">Send
        Notification</button>
</form>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus"
    [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>